import React from 'react';
import theme from '../../../../../theme';
import { CheckIcon, CloseIcon } from '../../../../../components/icons';
import { Container } from './styles';

type Props = {
    title: string;
    valid: boolean;
}

const CheckPassword: React.FC<Props> = ({ title, valid }) => {
    return (
        <Container $valid={valid}>
            {valid ? (
                <CheckIcon iconColor={theme.successColor} />
            ) : (
                <CloseIcon iconColor={theme.errorColor} />
            )}
            <small>{title}</small>
        </Container>
    );
};

export { CheckPassword };
